<template>
  <div class="fill-height">
    <transition mode="out-in">
      <v-row v-if="About && About._slug == $language.current" key="loaded" class="content" no-gutters>
        <MomentumScrolling :content-classes="{'scrolling-content': true, 'paper-background': true, 'px-0 px-md-8': true, 'pb-16': true}">
          <Scribbles />
          <ClipMask label="Thanks to" key="clip-mask" class="full" :masked="false" />
          <v-col cols="12" class="px-8 px-md-0 py-0 col-md-8 offset-md-2 col-12">
            <h1 class="display-1 w-100 text-sans text-center">Thanks to</h1>
          </v-col>
          <v-col
            v-for="(block, i) in About.content"
            :key="i"
            cols="12"
            :md="block._repeaterType === 'Logo Row' && $vuetify.breakpoint.lgAndUp ? null : 8"
            :offset-md="block._repeaterType === 'Logo Row' && $vuetify.breakpoint.lgAndUp ? null : 2"
            class="px-0 px-md-0 py-0"
          >
            <component :is="repeaterComponents[block._repeaterType]" :data="block" />
          </v-col>
        </MomentumScrolling>
      </v-row>
      <v-row v-else class="fill-height paper-background" align="center" justify="center" key="loading">
        <Scribbles />
        <v-col cols="auto"><div class="animated-eye" /></v-col>
      </v-row>
    </transition>
  </div>
</template>

<script>
import GetAbout from '@/graphql/GetAbout.gql'
import ContentParagraphWithTitle from '@/atoms/ContentParagraphWithTitle'
import ContentTitle from '@/atoms/ContentTitle'
import ContentLogoRow from '@/atoms/ContentLogoRow'
import ContentNameList from '@/atoms/ContentNameList'
import ContentCredits from '@/atoms/ContentCredits'
import Scribbles from '@/molecules/Scribbles'
import ClipMask from '@/molecules/ClipMask'

import MomentumScrolling from '@/atoms/MomentumScrolling'

export default {
  name: 'AboutPage',
  components: {
    Scribbles,
    MomentumScrolling,
    ClipMask
  },
  apollo: {
    About: {
      query () {
        return GetAbout
      },
      variables () {
        return {
          slug: this.$language.current,
          status: 'PUBLISHED'
        }
      },
      result () {
        console.log(this.About)
        this.$root.$emit('scroll-to-saved-position')
      }
    }
  },
  data () {
    return {
      repeaterComponents: {
        Paragraph: ContentParagraphWithTitle,
        Title: ContentTitle,
        Credits: ContentCredits,
        'Name List': ContentNameList,
        'Logo Row': ContentLogoRow
      }
    }
  },
  metaInfo () {
    return {
      // about page browser title
      title: 'About',
      meta: [
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: 'About | PhotoVogue Festival 2020' }
      ]
    }
  }
}
</script>

<style scoped lang="scss">

::v-deep .scrolling-content {
  padding-top: 200px;

  @include breakpoint('md-and-up') {
    padding-top: 15vh;
  }
}

::v-deep .clip-mask {
  @include breakpoint(sm-and-down) {
    opacity: 1;
    top: 80px;

    p {
      font-size: 12vw;
    }
  }
}

// .absolute {
//   width: 100%;
//   height: 100%;
//   position: fixed;
//   top: 0;
//   left: 0;
//   z-index: -1;
// }

// .content {
//   // text-align: center;
//   // @include breakpoint('xl-only') {
//   //   font-size: 1.25rem;
//   // }
// }

// ::v-deep h3 {
//   text-transform: uppercase;
//   font-family: $body-font-family;
//   font-size: 1em !important;
//   // color: map-get(map-get($material-light, 'text'), 'secondary');
// }

// .paragraph-block,
// .credits-block,
// .name-list-block,
// .logo-row-block {
//   padding-bottom: 120px;

//   @include breakpoint('md-and-down') {
//     padding-bottom: 60px;
//   }
// }

// .title-block ::v-deep .col {
//   margin-top: 0 !important;
// }

// .paragraph-block,
// .credits-block {
//   max-width: 1100px;
//   margin: 0 auto;
// }

// .name-list-block {
//   max-width: 750px;
//   margin: 0 auto;
// }

</style>
